import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../http-error-handler.service';
import { EndpointLocationProviderService } from '../../shared/services/endpoint-location-provider.service';

@Injectable()
export class DashboardService {

    private handleError: HandleError;
    private env = environment;

    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private endpointLocationService: EndpointLocationProviderService) {
        this.handleError = httpErrorHandler.createHandleError('DashboardService');
    }
}
